/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { extract } from '@app/core';
import { Shell } from '@app/shell/shell.service';
import { CurrenciesListComponent } from '@app/settings/currencies/currencies-list/currencies-list.component';
import { LocalesListComponent } from '@app/settings/locales/locales-list/locales-list.component';
import { IndustriesListComponent } from '@app/settings/industries/industries-list/industries-list.component';
import { FacilitiesListComponent } from '@app/settings/facilities/facilities-list/facilities-list.component';
import { CountriesListComponent } from '@app/settings/countries/countries-list/countries-list.component';
import { CitiesListComponent } from '@app/settings/cities/cities-list/cities-list.component';
import { UsersListComponent } from '@app/settings/users/users-list/users-list.component';
import { RolesListComponent } from '@app/settings/users/roles/roles-list/roles-list.component';
import { CompaniesListComponent } from '@app/settings/companies/companies-list/companies-list.component';
import { TypesListComponent } from '@app/settings/types/types-list/types-list.component';
import { VenuesListComponent } from '@app/settings/venues/venues-list/venues-list.component';
import { WebsitesListComponent } from '@app/settings/websites/websites-list/websites-list.component';
import { CompaniesViewComponent } from '@app/settings/companies/companies-view/companies-view.component';
import { VenuesViewsComponent } from '@app/settings/venues/venues-views/venues-views.component';
import { MenuService } from '@app/core/menu/menu.service';
import { UsersViewComponent } from '@app/settings/users/users-view/users-view.component';
import { TemplatesListComponent } from '@app/settings/templates/templates-list/templates-list.component';

const routes: Routes = [
  Shell.childRoutes([
    // { path: 'hotels/:slug', component: HotelsViewComponent, data: { title: extract('Hotels view') } },
    { path: 'settings/currencies', component: CurrenciesListComponent, data: { title: extract('Currencies') } },
    { path: 'settings/locales', component: LocalesListComponent, data: { title: extract('Locales') } },
    { path: 'settings/industries', component: IndustriesListComponent, data: { title: extract('industries') } },
    { path: 'settings/facilities', component: FacilitiesListComponent, data: { title: extract('Facilities') } },
    { path: 'settings/countries', component: CountriesListComponent, data: { title: extract('Countries') } },
    { path: 'settings/cities/:id', component: CitiesListComponent, data: { title: extract('Cities') } },
    { path: 'settings/users', component: UsersListComponent, data: { title: extract('Users') } },
    { path: 'settings/roles', component: RolesListComponent, data: { title: extract('User roles') } },
    { path: 'settings/companies', component: CompaniesListComponent, data: { title: extract('Companies') } },
    { path: 'settings/types', component: TypesListComponent, data: { title: extract('Types') } },
    { path: 'settings/venues', component: VenuesListComponent, data: { title: extract('Venues') } },
    { path: 'settings/websites', component: WebsitesListComponent, data: { title: extract('Websites') } },
    {
      path: 'settings/companies/view',
      component: CompaniesViewComponent,
      data: { title: extract('Company') },
    },
    {
      path: 'settings/venues/view',
      component: VenuesViewsComponent,
      data: { title: extract('Venue') },
    },
    { path: 'settings/users/view', component: UsersViewComponent, data: { title: extract('User view') } },
    { path: 'settings/templates', component: TemplatesListComponent, data: { title: extract('Templates') } },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [MenuService],
})
export class SettingsRoutingModule {
  constructor(menuService: MenuService) {
    menuService
      .addItem({
        key: 'settings',
        icon: 'fal fa-cog',
        title: 'Settings',
        childrens: [],
      })
      .addItem({
        key: 'settings.currencies',
        requiredPermission: 'currencies.menu',
        path: '/settings/currencies',
        title: 'Currencies',
      })
      .addItem({
        key: 'settings.locales',
        requiredPermission: 'locales.menu',
        path: '/settings/locales',
        title: 'Locales',
      })
      .addItem({
        key: 'settings.industries',
        requiredPermission: 'industries.menu',
        path: '/settings/industries',
        title: 'industries',
      })
      .addItem({
        key: 'settings.facilities',
        requiredPermission: 'facilities.menu',
        path: '/settings/facilities',
        title: 'Facilities',
      })
      .addItem({
        key: 'settings.countries',
        requiredPermission: 'countries.menu',
        path: '/settings/countries',
        title: 'Countries',
      })
      .addItem({
        key: 'settings.users',
        requiredPermission: 'users.menu',
        path: '/settings/users',
        title: 'Users',
      })
      .addItem({
        key: 'settings.roles',
        requiredPermission: 'roles.menu',
        path: '/settings/roles',
        title: 'Roles',
      })
      .addItem({
        key: 'settings.companies',
        requiredPermission: 'companies.menu',
        path: '/settings/companies',
        title: 'Companies',
      })
      .addItem({
        key: 'settings.types',
        requiredPermission: 'types.menu',
        path: '/settings/types',
        title: 'Types',
      })
      .addItem({
        key: 'settings.venues',
        requiredPermission: 'venues.menu',
        path: '/settings/venues',
        title: 'Venues',
      })
      .addItem({
        key: 'settings.websites',
        requiredPermission: 'websites.menu',
        path: '/settings/websites',
        title: 'Websites',
      })
      .addItem({
        key: 'settings.templates',
        requiredPermission: 'templates.menu',
        path: '/settings/templates',
        title: 'Templates',
      });
  }
}
